import { useCallback } from "react";
import { fetchGiteaDashboardStatus, getCachedGiteaSummary } from "../api/dashboard.api";
import { useCachedDashboardQuery } from "./useCachedDashboardQuery";

export const useGiteaDashboardStatus = (enabled: boolean) => {
  const fetcher = useCallback((force?: boolean) => fetchGiteaDashboardStatus(force), []);
  return useCachedDashboardQuery(enabled, getCachedGiteaSummary, fetcher);
};
